module.exports = __webpack_public_path__ + "img/portraits_12_V.058c6fbf.webp";